import { NotificationsApiRemoteService } from '../../Services/api/notifications/notifications-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class  MarkAsReadNotificationsUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly NotificationsApi: NotificationsApiRemoteService) {}
    

  public async handle (notificationId: string): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.NotificationsApi.markAsRead(notificationId)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
